import { XStack } from '@my/ui'
import useEmblaCarousel from 'embla-carousel-react'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { FilterListItem } from './filter-list-item'
import { FilterListProps } from './group-filter'

export const FilterList = ({ filters = [], onFilterChange, activeFilters }: FilterListProps) => {
  const [emblaRef] = useEmblaCarousel(
    {
      slidesToScroll: 1,
      containScroll: 'keepSnaps',
      skipSnaps: true,
      align: 'start',
    },
    [WheelGesturesPlugin()]
  )
  return (
    <div style={{ overflow: 'hidden' }} ref={emblaRef as any}>
      <XStack height="auto" style={{ backfaceVisibility: 'hidden' }}>
        {filters.map((item) => (
          <FilterListItem
            minWidth={0}
            flexGrow={0}
            flexShrink={0}
            flexBasis="auto"
            key={item.value}
            item={item}
            onFilterChange={onFilterChange}
            activeFilters={activeFilters}
          />
        ))}
      </XStack>
    </div>
  )
}
